export function isOrderAlreadyCreated(data) {
  return (
    data?.alreadyExists === true || data?.message === 'Order already created'
  );
}

export function isSuccessfulOrderCreationResponse(response) {
  if (!response || response.status < 200 || response.status >= 300) {
    return false;
  }
  return Boolean(response.data?.order) || isOrderAlreadyCreated(response.data);
}
